export default __webpack_public_path__ + "static/media/Public-Notice-for-Web-Hindi-21102020.01017287.jpg";